import { render, staticRenderFns } from "./formSet.vue?vue&type=template&id=945e5832&scoped=true"
import script from "./formSet.vue?vue&type=script&lang=js"
export * from "./formSet.vue?vue&type=script&lang=js"
import style0 from "./formSet.vue?vue&type=style&index=0&id=945e5832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945e5832",
  null
  
)

export default component.exports